<template src='./home.html'>

</template>


<script>
import { get_ext_page } from "@/api/api.auth.js"

export default {
  data: function () {
    return {
      isBannerVisible: false,
      showPopup: false,
    };
  },

  methods: {
    getImg(nome) {
      return this.$load.getUrlImg() + "/home/" + nome;
    },

    dialogAcquistoBottom() {
      if (this.isBannerVisible == false) this.isBannerVisible = true;
      else {
        this.isBannerVisible = false;
        this.setCookie("username", this.role, 1);
      }
    },

    async conferma() {
      this.dialogAcquistoBottom();

      let res = await get_ext_page("offerte");
      setTimeout(() => {
        window.open(res.data, '_blank');
      })
    },

    checkCookie() {
      let user = this.getCookie("username");
      if (user != "") {
        this.showPopup = false;
        return;
      } else {
        this.showPopup = true;
        this.dialogAcquistoBottom();
      }
    },

    getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires;
    },
  },

  mounted() {
    if (this.role == "Cliente")
      this.checkCookie();
  },

  computed: {
    role() {
      return this.$store.getters["user/getRole"];
    },
  },

  watch: {
    role() {
      if (this.role == "Cliente")
        this.checkCookie();
    }
  },
};
</script>

<style scoped>
#v-banner {
  position: fixed;
  bottom: 5%;
  right: 1%;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)
}

.slide-from-left {
  animation: slideInFromLeft 1.2s ease-out forwards;
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(+100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes slideOutToLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(+110%);
  }
}

.slide-out-to-left {
  animation: slideOutToLeft 1.2s ease-out forwards;
}
</style>